// [AI GENERATED CODE] Updated Sentry init for v8 compatibility with React 19
import * as Sentry from "@sentry/react";
const secrets = require('../public_keys.json');

// [AI GENERATED CODE]
// Derives Sentry environment from public_keys.json sentry.env field.
// Controls sample rates and environment tagging in Sentry dashboard.
const SENTRY_ENV = secrets.sentry.env || 'development';
const IS_PROD = SENTRY_ENV === 'production';

// [AI GENERATED CODE]
// Environment-aware sample rates.
// Production uses low rates to control Sentry quota.
// Non-production uses full capture for QA observability.
const SAMPLE_RATES = {
  production: { sampleRate: 0.1, tracesSampleRate: 0.05 },
  preprod:    { sampleRate: 1.0, tracesSampleRate: 0.5  },
  default:    { sampleRate: 1.0, tracesSampleRate: 0.5  },
};
const rates = SAMPLE_RATES[SENTRY_ENV] || SAMPLE_RATES.default;

let DateToday = new Date();
let releaseVersionForSentry =
  SENTRY_ENV +
  '-' +
  DateToday.getFullYear() +
  '-' +
  DateToday.getMonth().toString().padStart(2, '0') +
  '-' +
  DateToday.getDate().toString().padStart(2, '0');

try {
  // [AI GENERATED CODE]
  // Sentry initialization aligned with Flutter SplashLive implementation.
  // Options mirror flutter sentry_flutter configuration where JS SDK equivalents exist.
  Sentry.init({
    dsn: secrets.sentry.dsn,
    environment: SENTRY_ENV,
    attachStacktrace: true,
    integrations: [Sentry.browserTracingIntegration()],
    release: releaseVersionForSentry,
    // [AI GENERATED CODE]
    // dist identifies the specific build artifact, same value as release.
    // Matches Flutter's options.dist = dist.
    dist: releaseVersionForSentry,
    attachStacktrace: true,
    // [AI GENERATED CODE]
    // Matches Flutter's options.sendDefaultPii = false.
    sendDefaultPii: false,
    // [AI GENERATED CODE]
    // Matches Flutter's options.enableAutoSessionTracking = true.
    autoSessionTracking: true,
    // [AI GENERATED CODE]
    // Matches Flutter's options.debug = true — scoped to non-production to avoid noisy logs.
    debug: !IS_PROD,
    sampleRate: rates.sampleRate,
    // [AI GENERATED CODE]
    // Matches Flutter's options.tracesSampleRate = 0.05.
    tracesSampleRate: rates.tracesSampleRate,
  });
} catch (e) {
  console.log('sentry key mismatch', e);
}
